import { createSlice } from "@reduxjs/toolkit";
import {
  getClients,
  addNewClient,
  updateClient,
  deleteClient,
  getClientById,
  getClientDetails,
  getAvailableContacts,
  getClientUnits,
  getClientsOverdue,
} from "./thunk";

export const initialState = {
  clients: [],
  clientDetails: null,
  clientInfo: null,
  contracts: [],
  additionalContact: null,
  availableContacts: [],
  clientUnits: null,
  error: null,
  isClientSuccess: false,
  isClientCreated: false,
  loading: false,
};
import { addNewContract } from "../thunks";
const clientsSlice = createSlice({
  name: "ClientsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Fetch clients
    builder.addCase(getClients.fulfilled, (state, action) => {
      state.clients = action.payload;
      state.isClientSuccess = true;
    });

    builder.addCase(getClients.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch clients";
      state.isClientSuccess = false;
    });
    builder.addCase(getClientsOverdue.fulfilled, (state, action) => {
      state.clients = action.payload; // Assuming `action.payload` contains client data
      state.isClientSuccess = true;
      state.error = null;
      state.loading = false;
    });

    builder.addCase(getClientsOverdue.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch clients";
      state.isClientSuccess = false;
    });

    builder.addCase(getClientsOverdue.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(getClientById.fulfilled, (state, action) => {
      state.clientDetails = action.payload;
      state.isClientSuccess = true;
      state.error = null;
    });

    builder.addCase(getClientById.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch client by ID";
      state.selectedClient = null; // Clear the selected client on failure
    });

    // Get client details
    builder.addCase(getClientDetails.fulfilled, (state, action) => {
      state.clientDetails = action.payload; // Keep full response

      // Break down the response
      const { contracts, additional_contact1, ...clientInfo } = action.payload;
      state.clientInfo = clientInfo;
      state.contracts = contracts;
      state.additionalContact = additional_contact1 || null;
      state.loading = false;
      state.error = null;
    });

    builder.addCase(getClientDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(getClientDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.error || "Failed to fetch client by ID";
      state.clientDetails = null;
      // Clear broken-down data too
      state.clientInfo = null;
      state.contracts = [];
      state.additionalContact = null;
    });

    // Get available contacts
    builder.addCase(getAvailableContacts.fulfilled, (state, action) => {
      state.availableContacts = action.payload;
      state.loading = false;
      state.error = null;
    });

    builder.addCase(getAvailableContacts.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(getAvailableContacts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.error || "Failed to fetch client by ID";
      state.availableContacts = [];
    });

    // Get Client Units
    builder.addCase(getClientUnits.fulfilled, (state, action) => {
      state.clientUnits = action.payload;
      // state.isClientSuccess = true;
      state.error = null;
    });

    builder.addCase(getClientUnits.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to fetch client by ID";
      // state.selectedClient = null; // Clear the selected client on failure
    });

    // Add new client
    builder.addCase(addNewClient.fulfilled, (state, action) => {
      state.clients.push(action.payload); // Add the new client to the list
      state.isClientCreated = true;
      state.error = null;
    });

    builder.addCase(addNewClient.rejected, (state, action) => {
      state.error = action.payload || "Failed to add client";
      state.isClientCreated = false;
    });

    // Update client
    builder.addCase(updateClient.fulfilled, (state, action) => {
      state.clients = state.clients.map((client) =>
        client.id === action.payload.id
          ? { ...client, ...action.payload }
          : client
      );

      // If this is the currently viewed client, update the detailed data too
      if (state.clientDetails && state.clientDetails.id === action.payload.id) {
        state.clientDetails = { ...state.clientDetails, ...action.payload };

        // Update the broken-down data
        const { contracts, additional_contact1, ...clientInfo } =
          state.clientDetails;
        state.clientInfo = clientInfo;
        state.contracts = contracts || [];
        state.additionalContact = additional_contact1 || null; // This will clear it if additional_contact1 is null/undefined
      }

      state.error = null;
    });

    builder.addCase(updateClient.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to update client";
    });

    // Delete client
    builder.addCase(deleteClient.fulfilled, (state, action) => {
      state.clients = state.clients.filter(
        (client) => client.id !== action.payload.clientId
      );
      state.error = null;
    });

    builder.addCase(deleteClient.rejected, (state, action) => {
      state.error = action.payload?.error || "Failed to delete client";
    });

    builder.addCase(addNewContract.fulfilled, (state, action) => {
      if (!state.contracts) {
          state.contracts = [];
      }
      state.contracts.push(action.payload);
    });
  },
});

export default clientsSlice.reducer;
